/**
 * Parse a `workflowId` query value. Empty/absent → undefined; non-numeric throws.
 *
 * @throws when `raw` is present but not a number.
 */
export function parseWorkflowId(raw: string | null): number | undefined {
  if (raw === null || raw === '') return undefined;
  const value = Number(raw);
  if (Number.isNaN(value)) {
    throw new Error(`Invalid workflowId query parameter: ${raw}`);
  }
  return value;
}
